import { Stack } from '@mui/material';
import { colors, Typography, Button } from '@sweep-io/sweep-design';
import { ProcessMining } from '@sweep-io/sweep-design/dist/icons';
import React, { useState } from 'react';
import EditTextarea from '../../components/common/editable-card/EditTextarea';

interface ChatPromptTempProps {
  onSendMessage: (message: string) => void;
  loading?: boolean;
}

export const DemoChatPrompt = ({ onSendMessage, loading }: ChatPromptTempProps) => {
  const [inputValue, setInputValue] = useState('');

  const handleGenerate = () => {
    if (inputValue.trim()) {
      onSendMessage(inputValue.trim());
      setInputValue('');
    }
  };

  return (
    <Stack gap={3} padding="16px">
      <Stack gap={1} alignItems="center">
        <Typography variant="h2" color={colors.grey[800]}>
          Create your Salesforce setup
        </Typography>
        <Typography variant="h4" color={colors.grey[700]}>
          Sweep will instantly design the ideal processes for you
        </Typography>
      </Stack>

      <Stack
        sx={{
          flex: 1,
          minHeight: '174px',
          padding: 2,
          background: colors.grey[100],
          borderRadius: '8px',
          border: `1px solid ${colors.blue[500]}`,
          boxShadow: 1,
        }}
      >
        <Stack height="100%" flex={1}>
          <Stack flex={1}>
            <Stack flex={1} direction="row" gap={1} alignItems="flex-start">
              <ProcessMining color={colors.blue[500]}/>
              <Stack flex={1}>
                <EditTextarea
                  setText={(newText: string) => setInputValue(newText)}
                  text={inputValue}
                  placeholder="Tell us about your business..."
                  onSubmit={handleGenerate}
                  submitOnEnter={true}
                />
              </Stack>
            </Stack>
          </Stack>
          <Stack direction="row" justifyContent="flex-end" alignItems="center">
            <Button
              variant="primary"
              size="small"
              onClick={handleGenerate}
              disabled={!inputValue.trim() || loading}
              loading={loading}
            >
              Generate
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
